import assertNever from "assert-never";
import React from "react";
import { Control, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { ComplianceFormQuestion } from "../../../messages";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import Question from "../../OnboardingSection/Question";
import SignatureBox from "../../SignatureBox/SignatureBox";

interface Props {
  question: ComplianceFormQuestion;
  control: Control;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  onError: (params: { title: string; message: string }) => void;
}

function ComplianceQuestion(props: Props) {
  const name = `question-${props.question.id}`;

  switch (props.question.type) {
    case "text":
      return (
        <Question.Input
          {...props.register(name, { required: true })}
          placeholder={translate(STRINGS.ENTER_TEXT_HERE)}
          autoFocus={true}
        />
      );

    case "phone_number":
      return (
        <Question.PhoneNumber
          control={props.control}
          name={name}
          autoFocus={true}
          disabled={false}
        />
      );

    case "plain_text":
      return <></>;

    case "radio":
      return (
        <Question.Section>
          {props.question.options.map((option) => (
            <Question.Radio
              key={option.id.toString()}
              {...props.register(name, { required: true })}
              value={option.id.toString()}
            >
              {option.title}
            </Question.Radio>
          ))}
        </Question.Section>
      );

    case "yesno":
      return (
        <Question.Section>
          <Question.Radio {...props.register(name, { required: true })} value="true">
            Yes
          </Question.Radio>
          <Question.Radio {...props.register(name, { required: true })} value="false">
            No
          </Question.Radio>
        </Question.Section>
      );

    case "signature":
      return (
        <Question.Section>
          <SignatureBox
            placeholder={translate(STRINGS.SIGN_HERE)}
            {...props.register(name, { required: true })}
            onSubmit={(data) => props.setValue(name, data)}
          />
        </Question.Section>
      );

    case "date":
      return <Question.Date {...props.register(name, { required: true })} />;

    case "document":
      return (
        <Question.Document
          fieldName={name}
          setValue={props.setValue}
          initialData={undefined}
          isDisabled={false}
          canUploadFromGallery={true}
          isSelfie={false}
          onClickDisabled={() =>
            props.onError({
              title: translate(STRINGS.WHOOPS),
              message: translate(STRINGS.CANNOT_EDIT_ANSWERS_IN_READ_ONLY_MODE),
            })
          }
        />
      );

    default:
      assertNever(props.question);
  }
}

export default ComplianceQuestion;
